import React, { useState } from "react";
import {
  Modal,
  Box,
  Typography,
  Grid,
  IconButton,
  Accordion,
  AccordionSummary,
  AccordionDetails,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { MdOutlineCloudUpload } from "react-icons/md";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import EditRoundedIcon from "@mui/icons-material/EditRounded";

import "../../Admin/influencerModal.css";
import { BoxWithBorder } from "../../Common/Components/BoxWithBorder";
import { InputWithLabel } from "../../Common/Components/InputWithLabel";
import { DropDown } from "../../Common/Components/DropDown";

// social platforms img
import instagram from "../../Assets/Img/instaAdmin.svg";
import youtube from "../../Assets/Img/yt-admin.svg";
import twitter from "../../Assets/Img/twitter-admin.svg";
import facebook from "../../Assets/Img/fb-admin.svg";
import twitch from "../../Assets/Img/twitter-admin.svg";
import snapchat from "../../Assets/Img/snapchat-admin.svg";
import quora from "../../Assets/Img/quara-admin.svg";
import reddit from "../../Assets/Img/reddit-admin.svg";
import linkedin from "../../Assets/Img/linkedin-admin.svg";

function BrandAddModal({ open, handleClose }) {
  const [brandForms, setBrandForms] = useState([0]);
  const [influencerForms, setInfluencerForms] = useState([0]);

  const handleAddBrand = () => {
    setInfluencerForms((prev) => [...prev, prev.length]);
  };

  if (open === undefined || handleClose === undefined) {
    console.error("Modal props 'open' and 'handleClose' are required.");
    return null;
  }
  const socialPlatforms = [
    { placeholder: "Instagram Handle", image: instagram },
    { placeholder: "Youtube Handle", image: youtube },
    { placeholder: "Facebook Handle", image: facebook },
    { placeholder: "Twitter Handle", image: twitter },
    { placeholder: "Twitch Handle", image: twitch },
    { placeholder: "Snapchat Handle", image: snapchat },
    { placeholder: "Quara Handle", image: quora },
    { placeholder: "Reddit Handle", image: reddit },
    { placeholder: "LinkedIn Handle", image: linkedin },
  ];

  return (
    <>
      <Modal open={open} onClose={handleClose}>
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: 900,
            maxHeight: "90vh",
            overflowY: "auto",
            bgcolor: "background.paper",
            borderRadius: 2,
            boxShadow: 24,
            p: 4,
            position: "relative",
          }}
        >
          {/* Close Icon */}
          <Box
            display="flex"
            justifyContent="space-between"
            alignItems="flex-start"
            mb={3}
          >
            <Box>
              <Typography variant="h6">Media Upload</Typography>
              <Typography variant="body2">
                Add your documents here, and you can upload up to 5 files max
              </Typography>
            </Box>
            <IconButton
              onClick={handleClose}
              sx={{ color: "#888", border: "none !important" }}
            >
              <CloseIcon />
            </IconButton>
          </Box>

          {/* Media Upload Placeholder */}
          <Grid container spacing={3}>
            <Grid item xs={12}>
              <BoxWithBorder title={"Basic Details"}>
                <Grid container spacing={3}>
                  <Grid item xs={12}>
                    <Box display="flex" flexDirection="column" rowGap={2}>
                      <Box display="flex" alignItems="center" gap={3}>
                        <Box sx={{ position: "relative" }}>
                          <Box
                            width="120px"
                            height="120px"
                            className="profile-image-border"
                            sx={{
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                              flexDirection: "column",
                              color: "#6B8E76",
                              gap: "12px",
                              cursor: "pointer",
                            }}
                          >
                            <MdOutlineCloudUpload size={36} />
                            <Typography fontSize="12px" fontWeight={600}>
                              Upload Photo
                            </Typography>
                          </Box>
                        </Box>
                        <Box
                          display="flex"
                          flexDirection="column"
                          rowGap="8px"
                          sx={{
                            fontSize: "16px",
                            color: "#3C3C4399",
                            fontWeight: 400,
                          }}
                        >
                          <Typography>
                            Upload Your Profile Photo here
                          </Typography>
                          <Typography>Max 5 MB files allowed</Typography>
                          <Typography>
                            Supported File: .jpg, .jpeg, .png
                          </Typography>
                        </Box>
                      </Box>
                    </Box>
                  </Grid>
                </Grid>
              </BoxWithBorder>
            </Grid>
          </Grid>

          {/* Add Influencer Header */}
          <Box display="flex" justifyContent="space-between" mb={2} mt={2}>
            <Typography variant="h6" className="add-influencer">
              Add Brand
            </Typography>
            <Typography
              className="increment-influencer"
              variant="h6"
              sx={{ cursor: "pointer" }}
              onClick={handleAddBrand}
            >
              + Add Brand
            </Typography>
          </Box>

          {/* Influencer Form Sections */}
          {influencerForms.map((_, index) => (
            <Grid container spacing={3} key={index}>
              <Grid item xs={12}>
                <Accordion
                  defaultExpanded={index === 0}
                  sx={{
                    mt: index !== 0 ? 3 : 0, // Add margin-top if not the first accordion
                  }}
                >
                  <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                    <Typography
                      className="influencer-modal-text"
                      variant="subtitle1"
                      fontWeight={600}
                    >
                      Brand {index + 1}
                    </Typography>
                  </AccordionSummary>
                  <AccordionDetails>
                    <Grid container spacing={3}>
                      <Grid item xs={12}>
                        <Typography
                          className="basic-details-influencer"
                          variant="h6"
                          fontWeight={600}
                        >
                          Basic Details
                        </Typography>
                      </Grid>
                      <Grid item xs={6} className="form-name-input-wrapper">
                        <InputWithLabel
                          label="Brand Name"
                          placeholder="Enter Brand Name"
                        />
                      </Grid>
                      <Grid item xs={6} className="form-name-input-wrapper">
                        <Box display="flex" flexDirection="column" gap={1}>
                          <Typography
                            className="category-admin-drop"
                            variant="body2"
                          >
                            Categories
                          </Typography>
                          <DropDown
                            placeholder="Select Category"
                            options={[
                              { label: "Fashion", value: "fashion" },
                              { label: "Tech", value: "tech" },
                              { label: "Travel", value: "travel" },
                              { label: "Food", value: "food" },
                            ]}
                          />
                        </Box>
                      </Grid>
                      <Grid item xs={6} className="form-name-input-wrapper">
                        <InputWithLabel
                          label="Registered By"
                          placeholder="Enter Your Name"
                        />
                      </Grid>

                      <Grid item xs={6} className="form-name-input-wrapper">
                        <InputWithLabel
                          label="Designation"
                          placeholder="Enter Your Designation"
                        />
                      </Grid>
                      <Grid item xs={6} className="form-name-input-wrapper">
                        <InputWithLabel
                          label="Phone"
                          placeholder="Enter Your Phone"
                        />
                      </Grid>
                      <Grid item xs={6} className="form-name-input-wrapper">
                        <InputWithLabel
                          label="Email"
                          placeholder="Enter Your Email Id"
                        />
                      </Grid>
                      <Grid item xs={12} className="form-name-input-wrapper">
                        <InputWithLabel
                          label="Location"
                          placeholder="Enter Your Location"
                        />
                      </Grid>
                      <Grid item xs={12} className="form-name-input-wrapper">
                        <Typography
                          className="basic-details-influencer"
                          variant="h6"
                          fontWeight={600}
                        >
                          Social Platforms
                        </Typography>
                      </Grid>
                      {socialPlatforms.map((platform, index) => (
                        <Grid item xs={4} key={index}>
                          <div className="input-wrapper">
                            <img
                              src={platform.image}
                              alt={platform.placeholder.split(" ")[0]}
                              className="input-icon"
                            />
                            <input
                              type="text"
                              placeholder={platform.placeholder}
                              className="custom-input-admin"
                            />
                          </div>
                        </Grid>
                      ))}
                    </Grid>
                  </AccordionDetails>
                </Accordion>
              </Grid>
            </Grid>
          ))}

          {/* Upload Button */}
          <Box display="flex" justifyContent="flex-end" mt={4}>
            <button className="upload-btn">Upload</button>
          </Box>
        </Box>
      </Modal>
    </>
  );
}

export default BrandAddModal;
